import { AlertaService } from './alerta.service';
import { Component, OnInit, Inject } from '@angular/core';

@Component({
  selector: 'app-alerta',
  templateUrl: './alerta.component.html',
  styleUrls: ['./alerta.component.css']
})
export class AlertComponent implements OnInit {
  mensaje: any;

  constructor(@Inject(AlertaService) private servicioAlerta: AlertaService) {
  }

  ngOnInit() {
    this.servicioAlerta.getMensaje().subscribe(mensaje => this.mensaje = mensaje);
  }
}



// WEBPACK FOOTER //
// ./src/app/alerta/alerta.component.ts